var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatermark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 425.178,
    height: 809.5,
    viewBox: "0 0 425.178 809.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2.508,
    y1: -0.009,
    x2: 2.508,
    y2: 3.548,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfa168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#bfa168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#c0a269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#c1a369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#c2a46a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#c3a46b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#c4a56b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#c5a66c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#c6a76c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#c7a76d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#c8a86e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#c9a96e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#caa96f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#cbaa6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#ccab70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#cdac71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#cead71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#cead72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#cfae72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#d0af73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#d1af74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#d2b074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#d3b175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#d4b275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#d5b376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#d6b376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#d7b477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#d8b578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#d9b678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#dab679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#dbb779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#dcb87a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ddb87b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M35,40.961H393.029v809.5H35Zm0,0",
    transform: "translate(-35 -40.961)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 359.947,
    height: 828.969,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M.039.961h357.6v809.5H.039Zm0,0",
    transform: "translate(-0.039 -0.961)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M.246,1H355.591V808.154H.246Zm0,0",
    transform: "translate(-0.246 -1)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M323.083,398.953a54.563,54.563,0,0,0-20.622-11.419,75.867,75.867,0,0,0-23.945-2.855,126.536,126.536,0,0,0-24.542,3.451c-1.492.3-2.856.682-4.3,1.108-1.534.425-3.11.894-4.687,1.406a117.462,117.462,0,0,0-14.529,5.581,132.351,132.351,0,0,0-40.264,29.186,196.733,196.733,0,0,0-16.149,19.471c-1.619,2.216-3.152,4.389-4.643,6.647-1.62,2.258-3.153,4.644-4.644,7.072-1.62,2.514-3.238,5.028-4.729,7.628a247.573,247.573,0,0,0-21.133,46.4,290.826,290.826,0,0,0-11.717,49.893,350.544,350.544,0,0,0-4.219,52.577v.043c.938-1.022,1.875-2.088,2.813-3.153.468-.51.894-1.065,1.32-1.619a91.613,91.613,0,0,0,5.582-7.286c1.406-2,2.727-4.09,4.005-6.306.255-.426.553-1.022.809-1.448,1.022-1.747,2.045-3.536,2.982-5.369.213-.469.426-.979.639-1.406,1.023-1.96,1.96-4.005,2.854-6.05.17-.383.3-.767.426-1.151a25.166,25.166,0,0,0,1.065-2.683c1.492-10.822,3.451-21.6,5.8-32.34a306.2,306.2,0,0,1,10.311-36.514c.469-1.236.852-2.472,1.236-3.665,1.576-4.133,3.152-8.266,4.9-12.4a263.55,263.55,0,0,1,12.313-25.735c3.409-6.135,6.987-12.186,10.822-17.98,3.878-5.753,7.883-11.547,12.4-17a150.5,150.5,0,0,1,14.486-15.467,114.969,114.969,0,0,1,16.958-13.038,85.894,85.894,0,0,1,10.1-5.581c1.576-.767,3.111-1.448,4.687-2.173a93.649,93.649,0,0,1,25.394-6.775,50.655,50.655,0,0,1,14.061,1.918,54.7,54.7,0,0,1,6.6,2.258l6.263,2.6a82.453,82.453,0,0,1,11.972,6.6c1.832,1.363,3.75,2.684,5.5,4.262a54.66,54.66,0,0,1,5.2,4.772,42.413,42.413,0,0,1,7.839,11.589c1.023,2.088,1.832,4.3,2.727,6.391.81,2.215,1.492,4.388,2.174,6.519a156.583,156.583,0,0,1,5.369,26.672,161.837,161.837,0,0,1-2.9,53.983,209.722,209.722,0,0,1-7.584,25.905,249.171,249.171,0,0,1-10.907,24.584c-1.065,1.96-2.088,4.005-3.11,5.965l-3.281,5.794c-2.3,3.92-4.687,7.669-7.031,11.462l-3.834,5.5c-1.278,1.875-2.472,3.707-3.92,5.454-2.812,3.536-5.454,7.116-8.521,10.438a177.858,177.858,0,0,1-40.733,34.981A186.739,186.739,0,0,1,201.652,669l-6.434,1.7c-1.065.255-2.173.553-3.237.767l-3.281.682-6.562,1.278c-2.173.468-4.388.682-6.561,1.065l-6.6.981c-2.3.255-4.559.468-6.86.6a83.1,83.1,0,0,1-13.8-.213l-4.559-.383-.469-4.6c-.937-9.843-1.491-19.642-1.661-29.528-1.108.6-2.173,1.236-3.281,1.79-.128.043-.255.17-.384.213-4.473,2.3-8.99,4.474-13.634,6.477.469,5.155,1.023,10.268,1.662,15.381l1.065,8.053-7.712-2.47a111.449,111.449,0,0,1-23.519-10.695,6.956,6.956,0,0,1-.6-.427c-1.789-1.107-3.579-2.3-5.283-3.494a108.525,108.525,0,0,1-9.8-7.882c-1.278-1.193-2.471-2.344-3.707-3.58a6.427,6.427,0,0,1-.767-.767,124.257,124.257,0,0,1-16.02-20.28A169.211,169.211,0,0,1,47.8,600.955l-2.386-5.879c-.767-1.96-1.449-4.005-2.173-6.008-1.449-4.005-2.727-8.053-3.877-12.143a224.39,224.39,0,0,1-5.624-24.8,248.712,248.712,0,0,1-3.025-50.618A290.883,290.883,0,0,1,37.4,451.4a271.05,271.05,0,0,1,15.126-48.274c1.534-3.92,3.451-7.712,5.2-11.547.98-1.918,1.96-3.749,2.9-5.666L62.07,383.1l1.576-2.727a200.026,200.026,0,0,1,13.677-21.39,215.521,215.521,0,0,1,16.148-19.6A221.944,221.944,0,0,1,111.921,322l3.409-2.854,3.324,2.982a81.485,81.485,0,0,0,34.853,18.449,75.771,75.771,0,0,0,11.547,1.918c1.576.17,3.068.255,4.644.341,1.193.043,2.385.085,3.621.085a116.583,116.583,0,0,0,20.2-1.62c6.86-1.022,13.592-2.3,20.2-3.962a108.209,108.209,0,0,0,19.044-6.647,67.852,67.852,0,0,0,8.692-4.687,46.557,46.557,0,0,0,5.369-4.048c.809-.639,1.534-1.236,2.3-1.96.853-.767,1.62-1.534,2.387-2.3,3.963-3.878,7.456-8.1,9.459-12.527a18.4,18.4,0,0,0,1.321-4.005,13.159,13.159,0,0,0,.3-3.877,21.947,21.947,0,0,0-2.471-8.053,25.469,25.469,0,0,0-5.5-6.519,23.337,23.337,0,0,0-2.9-2v8.394a16.192,16.192,0,0,1,2.941,6.6,14.118,14.118,0,0,1,.3,4.262,20.787,20.787,0,0,1-.682,3.749,17.95,17.95,0,0,1-1.066,3.238l-.3.894-.426.767-.809,1.62v.043a33.193,33.193,0,0,1-4.644,6.263,31.969,31.969,0,0,1-3.919,3.706c-6.732,5.454-14.316,8.692-21.9,10.994a140.543,140.543,0,0,1-22.966,4.6,102.657,102.657,0,0,1-23.733.256c-1.534-.171-3.153-.469-4.729-.724-.383-.085-.809-.129-1.193-.214-1.107-.255-2.3-.468-3.409-.767-.809-.213-1.661-.383-2.556-.682a61.892,61.892,0,0,1-21.772-11.333,67.714,67.714,0,0,1-8.735-8.735l-4.048-4.815,5.369-3.324a190.889,190.889,0,0,1,31.7-15.382v-5.2a225.337,225.337,0,0,0-36.174,14.614l-4.73,2.429-2.3-4.815a93.033,93.033,0,0,1-8.1-27.44c-.639-4.687-1.022-9.288-1.236-13.932s-.255-9.331-.128-13.976l.255-5.666,5.54.682a212.567,212.567,0,0,0,38.986.554c2.642-.17,5.283-.426,7.924-.682,1.577-.17,3.068-.3,4.6-.512,2.344-.255,4.687-.512,7.072-.809l9.715-1.406,9.672-1.79a233.77,233.77,0,0,0,51-16.1c1.534-.724,3.11-1.406,4.6-2.13a150.177,150.177,0,0,0,16.873-9.673A140.5,140.5,0,0,0,298.029,179.1c2.045-2.513,4.09-5.027,6.178-7.541,1.875-2.642,3.75-5.2,5.625-7.882,1.661-2.769,3.409-5.454,5.027-8.266,1.534-2.812,3.025-5.71,4.346-8.65,5.326-11.674,8.862-24.244,8.181-36.6a54.778,54.778,0,0,0-3.919-17.895,47.481,47.481,0,0,0-4.134-8.181l-1.235-1.96-1.363-1.875c-.427-.6-.853-1.193-1.363-1.832l-1.492-1.662a46.339,46.339,0,0,0-14.272-10.907,58.788,58.788,0,0,0-17.64-5.283,100.188,100.188,0,0,0-18.96-.767c-.682,0-1.278.128-1.918.128a31.231,31.231,0,0,0-2.514,4.9,58.944,58.944,0,0,1,18.79,2.769,41.817,41.817,0,0,1,16.958,10.226A47.527,47.527,0,0,1,304.8,94.439l.128.3.043.341a87.348,87.348,0,0,1,2.216,13.422,58.593,58.593,0,0,1-.341,13.932,83.074,83.074,0,0,1-8.223,25.863,138.2,138.2,0,0,1-14.1,22.327A136.458,136.458,0,0,1,266.8,190.006a134.358,134.358,0,0,1-15.125,11.76c-1.576,1.065-3.067,2.13-4.6,3.11-.468.3-.852.639-1.277.9A158.159,158.159,0,0,1,222.4,217.531a190.394,190.394,0,0,1-37.792,10.609c-.682.214-1.406.384-2.173.554a110.493,110.493,0,0,1-12.825,1.96q-2.237.255-4.6.384c-18.534,1.449-38.815.682-38.815.682-2.642-.043-5.241-.341-7.8-.512l-5.284-.384.6-5.454a220.513,220.513,0,0,1,7.072-35.236,210.87,210.87,0,0,1,13.166-33.4,227.574,227.574,0,0,1,18.577-30.592,187.465,187.465,0,0,1,12.441-15.552c-.128-5.8-.34-11.12-.724-15.935a172.112,172.112,0,0,0-22.327,20.111,211.176,211.176,0,0,0-23.945,31.1A185.765,185.765,0,0,0,91.043,218.98l-.895,6.306L84.226,223.2A122.565,122.565,0,0,1,50.055,205.09a101.99,101.99,0,0,1-25.82-29.314A119.784,119.784,0,0,1,9.706,139.645c-.639-3.2-1.278-6.434-1.662-9.715-.256-3.237-.724-6.518-.767-9.757-.213-3.238-.043-6.562,0-9.8l.384-4.986c.128-1.619.383-3.237.639-4.857A108.549,108.549,0,0,1,20.954,63.548a140.484,140.484,0,0,1,23.6-30.677A112.388,112.388,0,0,1,76.6,10.971a125.059,125.059,0,0,1,30.719-9.246.425.425,0,0,0-.213-.17,2.063,2.063,0,0,0-.469-.3,3.121,3.121,0,0,0-1.32-.17,118.368,118.368,0,0,0-38.39,10.183A120.412,120.412,0,0,0,49.5,21.282a126.057,126.057,0,0,0-15.594,12.91A103.939,103.939,0,0,0,20.784,49.743c-1.023,1.406-1.875,2.812-2.77,4.261l-1.363,2.13L15.5,58.393c-.767,1.534-1.577,3.025-2.258,4.6-.724,1.534-1.449,3.068-2.13,4.644a121.917,121.917,0,0,0-9.842,39.71,132.178,132.178,0,0,0,0,20.537,122.79,122.79,0,0,0,3.11,20.239,106.933,106.933,0,0,0,16.574,36.813,112.683,112.683,0,0,0,13,15.424A105.487,105.487,0,0,0,49.416,213.1a128.191,128.191,0,0,0,36.174,16.915l3.622,1.066-.085,4.005v.213c-.085,6.263.213,12.526.682,18.832q.383,4.666.895,9.459l.554,4.729c.17,1.491.469,2.941.682,4.432,2.216,11.844,7.328,23.221,13.847,33.7l2.642,4.347-4.218,2.769a225,225,0,0,0-43.8,38.389,248.672,248.672,0,0,0-32.935,48.317c-9.246,17.3-16.745,35.534-21.218,54.495-1.15,4.729-1.96,9.5-2.684,14.316-.682,4.772-1.193,9.714-1.619,14.614C1.056,493.542.5,503.426.417,513.312a293.88,293.88,0,0,0,1.236,29.4A219.154,219.154,0,0,0,6.51,571.556c4.474,18.875,12.058,37.025,23.051,52.834a134.075,134.075,0,0,0,17.853,20.834l.937.938c1.96,1.789,3.963,3.536,5.965,5.283a124.664,124.664,0,0,0,12.143,9.034c1.576,1.022,3.153,2,4.729,2.982.511.34,1.065.554,1.619.894a130.918,130.918,0,0,0,24.457,10.908,165.048,165.048,0,0,0,28.078,6.22l3.706.469.724,3.706a248.484,248.484,0,0,0,13.976,48.7,160.721,160.721,0,0,0,25.394,42.948,91.614,91.614,0,0,0,17.981,16.276,70.046,70.046,0,0,0,21.815,9.672,77.368,77.368,0,0,0,23.9,1.79c2-.256,4.175-.341,5.752-.682a14.849,14.849,0,0,0,4.517-1.577c.043-.043.128-.043.17-.128a83.877,83.877,0,0,1-12.228-.512,73.99,73.99,0,0,1-21.388-5.709,74.766,74.766,0,0,1-18.748-11.887A99.551,99.551,0,0,1,176.172,768.4a150.161,150.161,0,0,1-19.94-38.133A225.169,225.169,0,0,1,145.921,688.9l-.98-5.922,5.964-.086c4.262-.128,8.522-.255,12.74-.51,2.088-.129,4.133-.3,6.221-.512,2-.255,4.175-.554,6.221-.852a204.222,204.222,0,0,0,24.756-5.113,195.528,195.528,0,0,0,46.612-19.088A204.236,204.236,0,0,0,287.8,626.477c3.111-2.856,5.88-6.05,8.82-9.076,2.727-3.195,5.624-6.348,8.181-9.714a191.57,191.57,0,0,0,14.529-20.834l3.238-5.411,3.068-5.625L327.131,573l1.406-2.854,2.769-5.752c1.661-3.92,3.494-7.713,4.985-11.718l2.259-5.964,2.088-5.965a216.334,216.334,0,0,0,10.907-49.723c1.576-16.83.554-33.831-4.048-49.851C342.725,424.9,335.141,409.434,323.083,398.953Zm0,0",
    transform: "translate(-0.414 -1.077)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M43,78H206.612V328.872H43Zm0,0",
    transform: "translate(-43 -78)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M178.977,94.924a145.519,145.519,0,0,0-14.017,14.955,194.486,194.486,0,0,0-12.1,16.616c-3.323,4.985-6.732,10.609-10.61,17.6a274.545,274.545,0,0,0-16.914,37.495c-.554,1.448-.981,2.982-1.492,4.431-.937,7.968-2.13,15.552-3.451,22.8.256-.129.554-.171.809-.3-.255.128-.553.214-.809.341h-.043a244.069,244.069,0,0,1-10.524,39.752c-.043.085-.085.255-.17.427-.384,1.022-.768,1.916-1.151,2.854-.6,1.576-1.236,3.238-1.918,4.729a10.834,10.834,0,0,1-.426,1.065c-.937,2.174-1.959,4.3-2.982,6.434-.255.512-.512,1.022-.724,1.534-.3.554-.639,1.066-.894,1.619-.724,1.406-1.449,2.769-2.216,4.048-.3.512-.553,1.066-.894,1.577-1.363,2.3-2.727,4.473-4.175,6.561-1.832,2.642-3.793,5.156-5.838,7.626-.468.554-.894,1.151-1.321,1.62-1.789,2.088-3.621,4.048-5.539,5.965a4.085,4.085,0,0,1-.767.724c-.639.682-1.321,1.278-2,1.96-.937.894-1.874,1.746-2.855,2.6-.3.214-.512.426-.809.639-1.875,1.662-3.878,3.281-5.88,4.772a8.6,8.6,0,0,1-1.278.9c-3.067,2.215-6.221,4.26-9.5,6.178.214.3.341.639.554.894-.17-.255-.468-.554-.6-.809a117.1,117.1,0,0,1-15.253,7.451,98.569,98.569,0,0,0,10.95,8.181c3.366-.895,6.69-1.909,9.971-2.978-.128-.338-.128-.676-.256-.982a4.115,4.115,0,0,1,.3.938c4.388-1.407,8.606-2.978,12.825-4.723,1.619-.6,3.195-1.287,4.772-2.007,1.7-.72,3.366-1.45,4.942-2.174.085,0,.128-.085.17-.085,2.344-1.108,4.687-2.215,6.945-3.451.256-.128.469-.3.767-.426,1.577-.894,3.238-1.789,4.815-2.684.426-.255.9-.511,1.321-.724.512-.3,1.023-.6,1.577-.937.639-.384,1.321-.852,2-1.236,1.022-.682,2.088-1.321,3.152-1.96,1.023-.639,1.96-1.321,2.9-1.96,1.235-.852,2.428-1.661,3.664-2.513,2.173-1.533,4.261-3.111,6.391-4.73,34.171-26.843,57.137-62.548,68.257-106.135.768-3.067,1.492-6.263,2.216-9.544.3-1.236.51-2.47.767-3.664.468-2.045.852-4.048,1.236-6.221.34-1.62.6-3.281.937-4.943.3-1.661.554-3.322.852-5.027.341-2.088.639-4.133.981-6.221.128-.767.213-1.619.34-2.429,1.363-9.2,2.514-18.832,3.451-29.015v-.128c.341-3.622.682-7.329.938-11.036v-.043c.553-7.414,1.065-15,1.449-22.88.17-3.323.3-6.732.425-10.183-2.428,1.321-4.857,2.642-7.2,4.175A156.1,156.1,0,0,0,178.977,94.924Zm0,0",
    transform: "translate(-43.188 -78.051)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M50,61h98.167V180.982H50Zm0,0",
    transform: "translate(-50 -61)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M68.554,78.583l-9.928,1.406c-2.514.341-5.07.682-7.712.937v8.1h.34c-.085,0-.255.043-.34.043v81.209a46.311,46.311,0,0,0,5.282.768,95.726,95.726,0,0,0,22.583-.214,132.749,132.749,0,0,0,22.2-4.431c8.393-2.514,14.828-5.753,20.154-10.1a31.7,31.7,0,0,0,7.072-8.138c0-2.982.043-5.965.043-8.9V61.285A237.2,237.2,0,0,1,78.225,76.794Zm0,0",
    transform: "translate(-50.914 -61.285)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M50,71h87.26V190.982H50Zm0,0",
    transform: "translate(-50 -71)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M116.064,77.9a118.708,118.708,0,0,1-19.9,6.945A183.3,183.3,0,0,1,75.46,88.974a127,127,0,0,1-21.006,1.661c-1.151,0-2.387-.043-3.536-.085v95.142c.213-.255.383-.6.6-.894a198.364,198.364,0,0,1,16.617-19.983,135.89,135.89,0,0,1,41.755-30.166,129.789,129.789,0,0,1,16.788-6.349c.6-18.022,1.065-37.153,1.321-57.222-.9.6-1.7,1.278-2.684,1.918A94.755,94.755,0,0,1,116.064,77.9Zm0,0",
    transform: "translate(-50.918 -71.078)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M28.844,96h143.5v65.445H28.844Zm0,0",
    transform: "translate(-28.844 -96)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 152.705,
    height: 65.445,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M.844.719H136.506V58.324H.844Zm0,0",
    transform: "translate(-0.844 -0.719)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M.844,1H133.438V55.111H.844Zm0,0",
    transform: "translate(-0.844 -1)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M115.161,35.767C109.963,34.531,75.877,22.6,65.4,18c-.682-.3-1.406-.639-2.088-.895-1.321-.639-2.642-1.193-3.92-1.747-2.13-.937-4.176-1.875-6.178-2.77C45.583,9.18,39.022,6.155,34.463,4.578a54.228,54.228,0,0,0-17-3.238c-4.218,0-7.712.852-10.268,2.514C3.572,6.2,1.57,10.373,1.016,16.593.164,33.466,24.535,39.985,39.149,42.328c.682.128,1.363.256,2.173.426.213.043.383.043.6.085.767.128,1.577.213,2.471.426h.128c.852.085,1.747.213,2.6.3a5.334,5.334,0,0,0,.81.128c.937.128,1.96.213,2.982.383h.213c1.023.128,2.088.213,3.068.341a5.864,5.864,0,0,0,.852.128c1.108.128,2.216.256,3.409.384h.043c1.15.128,2.343.213,3.536.383a5.89,5.89,0,0,1,.852.128c1.15.128,2.3.213,3.536.341.256,0,.469.043.682.043.98.128,1.96.17,2.94.3.384.043.724.043,1.108.085,1.193.128,2.343.256,3.494.341h.3c1.108.128,2.173.213,3.281.3a7.083,7.083,0,0,1,.937.128c2.343.213,4.6.383,6.775.6.3,0,.511.043.767.043,2.173.17,4.218.384,6.093.511a1.452,1.452,0,0,1,.426.043c.937.085,10.524.852,10.61.895,8.862,0,17.468-.426,25.863-1.193a133.761,133.761,0,0,1-14.018-11.589Zm0,0",
    transform: "translate(-0.994 -1.34)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M43,43H293.872V250.242H43Zm0,0",
    transform: "translate(-43 -43)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M158.592,45.881c-49.467,0-88.027-.809-114.784-2.428v6.86C64.729,51.676,79.94,54.1,90.165,57.726a39.276,39.276,0,0,1,25.011,24.8,93.493,93.493,0,0,1,4.431,20.324c.256,1.789.427,3.706.639,5.581.384,4.388.639,9.118.852,14.188.043,2.3.085,4.687.129,7.072,0,1.918.085,3.793.085,5.753v24.67a4.019,4.019,0,0,0,.682-.17,3.329,3.329,0,0,1-.682.3V242.6a102.979,102.979,0,0,0,11.717-1.833c.6-.17,1.236-.3,1.789-.512l.6-.17a185.766,185.766,0,0,0,36.855-10.311A160.587,160.587,0,0,0,194.937,218.4c1.363-.809,2.556-1.789,3.834-2.6V163.86c-.085,0-.255-.043-.383-.043a1.055,1.055,0,0,1,.383.043v-28.5c0-21.261,1.491-37.2,4.687-48.358a47.37,47.37,0,0,1,1.449-4.517,2.864,2.864,0,0,1,.256-.639,45.53,45.53,0,0,1,2.045-4.6,50.109,50.109,0,0,1,3.237-5.284A39.89,39.89,0,0,1,229.96,57.64c10.226-3.579,25.479-5.964,46.357-7.37V43.41C246.79,45.029,207.293,45.881,158.592,45.881Zm0,0",
    transform: "translate(-43.809 -43.41)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1127",
    "data-name": "Group 1127",
    transform: "translate(-1456 -2298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_15_16",
    "data-name": "Component 15 \\u2013 16",
    transform: "translate(1456 2298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1059",
    "data-name": "Group 1059",
    transform: "translate(67.148)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1058",
    "data-name": "Group 1058",
    transform: "translate(0 -10.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1057",
    "data-name": "Group 1057",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1056",
    "data-name": "Group 1056",
    transform: "translate(0.426 10.481)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1050",
    "data-name": "Group 1050",
    transform: "translate(-0.426 -10.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1049",
    "data-name": "Group 1049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1048",
    "data-name": "Group 1048",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1047",
    "data-name": "Group 1047",
    transform: "translate(2.684 10.907)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1046",
    "data-name": "Group 1046",
    transform: "translate(1.829 0.844)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M.41,1.074V805.715H353.156V1.074Zm0,0",
    transform: "translate(-0.449 -1.108)",
    fill: "url(#linear-gradient)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1055",
    "data-name": "Group 1055",
    transform: "translate(-0.426 -10.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1054",
    "data-name": "Group 1054"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1053",
    "data-name": "Group 1053",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1052",
    "data-name": "Group 1052",
    transform: "translate(2.684 10.907)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1051",
    "data-name": "Group 1051",
    transform: "translate(1.829 0.844)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M.41,1.074V805.715H353.156V1.074Zm0,0",
    transform: "translate(-0.449 -1.108)",
    fill: "url(#linear-gradient)"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1061",
    "data-name": "Group 1061",
    transform: "translate(154.408 404.004)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1060",
    "data-name": "Group 1060",
    transform: "translate(2.045 0.554)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M43.188,78.051v250.1H202.24V78.051Zm0,0",
    transform: "translate(-43.188 -78.051)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1063",
    "data-name": "Group 1063",
    transform: "translate(230.761 218.576)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1062",
    "data-name": "Group 1062",
    transform: "translate(9.971 3.111)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M50.914,61.285V171.851h77.332V61.285Zm0,0",
    transform: "translate(-50.914 -61.285)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1065",
    "data-name": "Group 1065",
    transform: "translate(230.761 327.651)",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1064",
    "data-name": "Group 1064",
    transform: "translate(10.013 0.852)",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M50.918,71.078V185.692h77.077V71.078Zm0,0",
    transform: "translate(-50.918 -71.078)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1079",
    "data-name": "Group 1079",
    transform: "translate(0 600.338)",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1078",
    "data-name": "Group 1078",
    transform: "translate(-9.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1077",
    "data-name": "Group 1077",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1076",
    "data-name": "Group 1076",
    transform: "translate(9.203 7.84)",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1070",
    "data-name": "Group 1070",
    transform: "translate(-9.203 -7.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1069",
    "data-name": "Group 1069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1068",
    "data-name": "Group 1068",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1067",
    "data-name": "Group 1067",
    transform: "translate(9.203 10.907)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1066",
    "data-name": "Group 1066",
    transform: "translate(1.64 3.707)",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M.918,1.34V49.06H130.445V1.34Zm0,0",
    transform: "translate(-1.748 -1.34)",
    fill: "url(#linear-gradient)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1075",
    "data-name": "Group 1075",
    transform: "translate(-9.203 -7.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1074",
    "data-name": "Group 1074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1073",
    "data-name": "Group 1073",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1072",
    "data-name": "Group 1072",
    transform: "translate(9.203 10.907)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1071",
    "data-name": "Group 1071",
    transform: "translate(1.64 3.707)",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M.918,1.34V49.06H130.445V1.34Zm0,0",
    transform: "translate(-1.748 -1.34)",
    fill: "url(#linear-gradient)"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1081",
    "data-name": "Group 1081",
    transform: "translate(154.408 22.242)",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1080",
    "data-name": "Group 1080",
    transform: "translate(8.82 4.474)",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M43.809,43.41V242.6H276.317V43.41Zm0,0",
    transform: "translate(-43.809 -43.41)",
    fill: "url(#linear-gradient)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermark);
export default __webpack_public_path__ + "static/media/Watermark.1b1c90f6f0d70db5b7caf0009083cebb.svg";
export { ForwardRef as ReactComponent };